import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/publish/bulk`;

export const ROUTE: RouteDefinition = `${baseRoute}/publish/bulk`;

export const URL = (): RouteDefinition => `${baseRoute}/publish/bulk`;
